import { QueryClient } from "@tanstack/vue-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // On page reload the access token is not yet in memory until /refresh
      // resolves. Disable automatic retries so failures propagate quickly.
      retry: 1,
      staleTime: 1000 * 60, // 1 minute
    },
  },
});
